import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout/layout"
import AboutHeader from "../components/aboutHeader/aboutHeader"

function AboutPage() {
  return (
    <Layout>
      <Helmet>
        <title>Junaid Elahi | About Us</title>
      </Helmet>
      <div className="page">
        <div id="colorlib-page">
          <section className="ftco-section about-section">
            <div className="container">
              <AboutHeader />
              <div className="row d-flex justify-content-end mt-5">
                <div className="col-md-10">
                  <div className="profile ftco-animate" data-aos="fade-up">
                    <h2 className="mb-4">Profile</h2>
                    <h4 className="mb-4">
                      I'm a Frontend Developer from Islamabad, Pakistan. I aim
                      to make a difference through my creative solution.
                    </h4>
                    <p>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia and Consonantia, there live the blind
                      texts. Separated they live in Bookmarksgrove right at the
                      coast of the Semantics, a large language ocean.
                    </p>
                    <div className="row my-5">
                      <div className="col-md-6">
                        <p>
                          <strong>Name:</strong> <span>Junaid Elahi</span>
                        </p>
                        <p>
                          <strong>Address:</strong>{" "}
                          <span>Sector H-13 Islamabad, Pakistan.</span>
                        </p>
                        <p>
                          <strong>Phone:</strong> <span>+92-323-7144496</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="exp mt-5 ftco-animate" data-aos="fade-up">
                    <h2 className="mb-4">Experience</h2>
                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          UX &amp; Interaction Designer{" "}
                          <span> - Google Company</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2017 - Present</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          UX &amp; UI Designer <span> - QBootstrap.com</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2015 - 2017</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Designer &amp; Developer{" "}
                          <span> - Themeforest.net</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2014 - 2015</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Front-End Developer <span> - Big Comany</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2012 - 2014</p>
                      </div>
                    </div>
                  </div>

                  <div className="exp mt-5 ftco-animate" data-aos="fade-up">
                    <h2 className="mb-4">Education</h2>
                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Master Degree in Computer Science
                          <span> - Harvard University</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2013 - 2014</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Bacheclor of Science in Computer Science
                          <span> - Harvard University</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2009 - 2012</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Diploma in Information Technology
                          <span> - Oxford University</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2008 - 2010</p>
                      </div>
                    </div>

                    <div className="exp-wrap py-4">
                      <div className="desc">
                        <h4>
                          Front-End Developer <span> - Big Comany</span>{" "}
                        </h4>
                        <p className="location">Germany - Berlin</p>
                      </div>
                      <div className="year">
                        <p>2012 - 2014</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row mt-5 flex-column ftco-animate"
                data-aos="fade-up"
              >
                <div className="col-md-8">
                  <h2 className="mb-4">My Skills</h2>
                </div>
                <div className="col-md-6 animate-box">
                  <div className="progress-wrap">
                    <h4>Angular</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={75}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "75%" }}
                      >
                        <span>75%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 animate-box"
                  data-animate-effect="fadeInRight"
                >
                  <div className="progress-wrap">
                    <h4>jQuery</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={60}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "60%" }}
                      >
                        <span>60%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 animate-box">
                  <div className="progress-wrap">
                    <h4>HTML5</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={85}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "85%" }}
                      >
                        <span>85%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 animate-box"
                  data-animate-effect="fadeInRight"
                >
                  <div className="progress-wrap">
                    <h4>CSS3</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={90}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "90%" }}
                      >
                        <span>90%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 animate-box">
                  <div className="progress-wrap">
                    <h4>ReactJs</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={70}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "70%" }}
                      >
                        <span>70%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 animate-box"
                  data-animate-effect="fadeInRight"
                >
                  <div className="progress-wrap">
                    <h4>GatsbyJs</h4>
                    <div className="progress">
                      <div
                        className="progress-bar color-1"
                        role="progressbar"
                        aria-valuenow={80}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: "80%" }}
                      >
                        <span>80%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  )
}

export default AboutPage
